<!-- histogram.component.html -->
<div id="chart-container">
  <div id="my_dataviz" style="overflow-x: auto;"></div>
</div>
<p>
  <label># bins</label>
  <input type="number" min="0" max="100" step="1" value="20" id="nBin" [(ngModel)]="this.value" (ngModelChange)="this.updateChart()">
</p>
